import { FC, useCallback, useContext, useMemo } from 'react';

import { RedeliveryContext } from '../redelivery-context';

const RedeliveryDetailDeleteButton: FC<{ id: number }> = ({ id }) => {
  const { redeliveryDetails, setRedeliveryDetails } = useContext(RedeliveryContext);

  const disabled = useMemo(() => {
    return !!redeliveryDetails.get(id)?.unitCount || redeliveryDetails.size <= 1;
  }, [id, redeliveryDetails]);

  const deleteRedeliveryDetail = useCallback(
    (id: number) => {
      setRedeliveryDetails(prevState => {
        const detailsCopy = new Map(prevState);
        detailsCopy.delete(id);
        return detailsCopy;
      });
    },
    [setRedeliveryDetails]
  );

  return (
    <div className="grid-1 h-100 justify-items-start">
      <button
        className="align-self-center btn-close grid-1"
        disabled={disabled}
        onClick={() => deleteRedeliveryDetail(id)}
        style={disabled ? { opacity: 0.25 } : {}}
        type="button"
      >
        <span className="material-icons icon-large">delete</span>
      </button>
    </div>
  );
};

export default RedeliveryDetailDeleteButton;
